import { req } from '../../@api/request';

export default class QuotaService {
  static use = async (data: {
    type: string;
    iidx?: number;
    quantIdx?: number;
    algorithmIdx?: number;
  }) => {
    const result = await req.post(`/service-quota`, data);
    return result.data;
  };

  static count = async () => {
    const result = await req.get(`/service-quota`);
    return result.data;
  };

  static check = async (
    type: string,
    iidx?: number,
    quantIdx?: number,
    algorithmIdx?: number,
  ) => {
    const result = await req.get(
      `/service-quota/check?type=${type}&iidx=${iidx ?? ''}&quantIdx=${quantIdx ?? ''}&algorithmIdx=${algorithmIdx ?? ''}`,
    );
    return result.data;
  };
}
